<template>
  <div class="leave-msg">
    <pageHeader title="留言" />

    <div class="gray-block"></div>

    <div class="leave-msg-container">
      <span class="msg-label"
        >请输入您遇到的问题，我们收到后会立刻回复您：</span
      >
      <div class="msg-input">
        <van-field
          v-model="message"
          rows="8"
          type="textarea"
          placeholder="请输入"
        />
      </div>

      <div class="submit-btn" @click="submitMsg">提交</div>
    </div>

    <customerDialog
      v-if="customerDialogVirsble"
      v-model="customerDialogVirsble"
      @handleClose="dialogClose"
    />
  </div>
</template>

<script>
import pageHeader from "@/components/PageHeader";
import customerDialog from "@/components/CustomerDialog";
import { requestMethods } from "@m/api";
import { mapGetters } from "vuex";
export default {
  components: {
    pageHeader,
    customerDialog
  },
  data() {
    return {
      message: "",
      customerDialogVirsble: false
    };
  },
  computed: {
    ...mapGetters(["uuid", "userInfo"]),
  },
  methods: {
    /**
     *提交留言和反馈
     */
    async submitMsg() {
      try {
        await requestMethods(
          "/modules/words/sysWords/saveOrUpdate.htm",
          "post",
          {
            uuid: this.uuid,
            content: this.message
          }
        );
        this.$toast({
          message: '您的留言已提交！',
          position: "bottom",
        });
        this.customerDialogVirsble = true
      } catch (error) {
        this.$toast({
          message: error.message,
          position: "bottom",
        });
      }
    },
    dialogClose() {
      this.$router.go(-1)
    }
  },
};
</script>

<style lang="scss">
.leave-msg {
  .gray-block {
    background: #f4f4f4;
    width: 100%;
    height: 10px;
  }
  .leave-msg-container {
    padding: 40px;

    .msg-label {
      display: block;
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 28px;
      color: #333333;
      line-height: 36px;
      margin-bottom: 54px;
    }
    .msg-input .van-cell {
      background: #f4f4f4;
      border-radius: 10px;
    }
    .submit-btn {
      margin: 0 auto;
      margin-top: 40px;
      width: 640px;
      height: 80px;
      background: #ff7a3e;
      border-radius: 40px;
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 28px;
      color: #ffffff;
      line-height: 80px;
      text-align: center;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/leaveMsg/index.vue